import { useState } from "react";

/**
 * A choice kept for as long as the browser tab lives: which tab is showing, which fold is open.
 * It never touches the address or the browser's history, so the Back gesture is left alone.
 * Without storage (private mode) it lasts until the page closes.
 */
export function useRemembered<T extends string>(key: string, allowed: readonly T[], fallback: T): [T, (next: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const kept = sessionStorage.getItem(key);
      return kept !== null && (allowed as readonly string[]).includes(kept) ? (kept as T) : fallback;
    } catch {
      return fallback;
    }
  });
  const choose = (next: T): void => {
    setValue(next);
    try {
      sessionStorage.setItem(key, next);
    } catch {
      // the choice still holds for this page
    }
  };
  return [value, choose];
}
